import React, { useState } from "react";
import { useFormik } from "formik";
import TextFiled from "../../../components/common/InputField/TextFiled";
import MainButton from "../../../components/common/MainButton/MainButton";
import Heading from "../../../components/common/Typography/Heading";
import Paragraph from "../../../components/common/Typography/Paragraph";
import AuxiliaryText from "../../../components/common/Typography/AuxiliaryText";
import Spinner from "../../../components/common/Spinner";
import InteractiveText from "../../../components/common/Typography/InteractiveText";
import SpecialText from "../../../components/common/Typography/SpecialText";
import { validationSchema } from "../../../FormValidations/ForgotPasswordSchema";
import { ForgotPasswordMutation } from "../../../services/ForgotPassowrd";
import { useGraphQL } from "../../../context/GraphQLProvider";
import Alerts from "../../../components/common/Alerts/Alerts";
import StepBackButton from "../../../components/common/StepBackButton/StepBackButton";
import { POPUP_FORM_CONTENT_CLASS } from "../../../components/popup/popupLayoutSpec";

const ForgotPassword = ({ onClickHandler, onBackToLogin }) => {
    const graphqlService = useGraphQL();
    const [RequestStart, setRequetStart] = useState(false);
    const [step, setStep] = useState("A");

  const ForgotPasswordservice = (gql, email) => {
      ForgotPasswordMutation(gql, { 
          email,
      })
      .then((response) => {
          console.log(response);
          if (response.forgotPassword?.success){
              setStep('B');
              // onClickHandler();  
          }
      })
      .catch((error) => {
          Alerts.error(error);
      })
      .finally(() => {
        setRequetStart(false);
      });
  };

  const formik = useFormik({
      initialValues: {email: ""},
      validationSchema: validationSchema,
      onSubmit: (values, { resetForm }) => {
          const email = values.email;
          setRequetStart(true);
          ForgotPasswordservice(graphqlService, email);
      },
  });
  
  return (
    <>
      {RequestStart && <Spinner />}
      {step === "A" && (
        <>
          <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
            <div className={POPUP_FORM_CONTENT_CLASS}>
              <Heading
                variant={"h6"}
                className={
                  "flex items-center justify-center text-center text-offblack"
                }
              >
                Password Recovery
              </Heading>
              <div className="mt-10 xl:mt-8 w-full">
                <form>
                  <div className="flex justify-center w-full">
                    <div className="w-full mx-auto">
                      <TextFiled
                        label={"Email"}
                        variant={"medium"}
                        fullWidth
                        type="email"
                        name="email"
                        placeholder={"Enter your registered email"}
                        onChange={formik?.handleChange}
                        value={formik?.values?.email}
                        className={"bg-white autofill:bg-white border border-solid border-[#C0C0C0]"}
                        error={formik.touched.email && formik.errors.email ? formik.errors.email : null}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            if (formik.values.email && !formik.errors.email) {
                              formik.handleSubmit();
                            } else {
                              formik.setFieldTouched('email', true);
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex justify-center w-full">
                    <div className="w-full mx-auto">
                      <div className="flex items-center justify-between mt-10 w-full">
                        <StepBackButton onClick={onBackToLogin} />
                        <MainButton
                          type="button"
                          variant={"small"}
                          onClick={formik.handleSubmit}
                        >
                          Submit
                        </MainButton>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}

      {step === "B" && (
        <>
          <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
            <div className={POPUP_FORM_CONTENT_CLASS}>
              <Heading
                variant={"h6"}
                className={
                  "flex items-center justify-center text-center text-offblack"
                }
              >
                Password Reset
              </Heading>
              <div className="mt-10 xl:mt-8 w-full">
                <div className="flex justify-center w-full">
                  <div className="w-full mx-auto">
                    <Paragraph
                      variant={"BodyCompact"}
                      className={"text-offblack text-center"}
                    >
                      We've sent you an email with instructions to reset your password.
                      Follow the link in the email to create a new password.
                    </Paragraph>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ForgotPassword;
